// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable prefer-named-capture-group, prefer-regex-literals */
export const getBidFromUrl = (url: string) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
  const bid = url.match(RegExp("(manage\\/|account\\/bookings\\/)(\\d+)"))
  return bid ? bid[2] : ""
}
